import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import {cssCFButton} from 'module/CustomField/component/button/cssCFButton';
import Add from '@mui/icons-material/AddCircleOutline';

interface Props {
	onClick: () => void
}

export function AddCFRowButton({onClick}: Props) {
	return <Tooltip title={'Zeile hinzufügen'}>
		<Button
			css={cssCFButton.btn}
			size={'small'}
			onClick={onClick}
		>
			<Add/>
		</Button>
	</Tooltip>
}